import classNames from 'classnames'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { FloatingTooltip } from '../../Floating'

import * as styles from './FormFieldContainer.module.css'

function FormFieldContainer({
  Component = 'div',
  className = styles.FormFieldContainer,
  disabled,
  disabledClassName = styles.disabled,
  error,
  errorClassName = styles.error,
  ref,
  tooltip,
  tooltipPlacement = FLOATING_ELEMENT_PLACEMENT.top,
  ...restProps
}) {
  const mods = {
    [disabledClassName]: disabled,
    [errorClassName]: error,
  }

  const containerClassName = classNames(className, mods)

  return (
    <FloatingTooltip content={tooltip} placement={tooltipPlacement}>
      <Component {...restProps} className={containerClassName} ref={ref} />
    </FloatingTooltip>
  )
}

export default FormFieldContainer
